export default class MyEventsContextMenu {

    constructor(element) {

        this.contextMenu = element;

        this.event = element.closest(".my-events__item");

        this.toggleContextMenuButton = this.event.querySelector(".my-events__item-context-menu-button");

        this.contextMenuControls = this.event.querySelector(".my-events__item-context-menu-controls")

        this.copyURLControl = this.event.querySelector("[data-action='copy-url']");

        // Delete menu control in context menu
        this.deleteEventControl = this.event.querySelector("[data-action='delete']");
        
        // Confirm delete event control in modal
        this.confirmDeleteEventControl = this.event.querySelector(".modal-delete-event .content-modal__button--confirm");

        // Modal messages
        this.copiedEventURLModal = document.getElementById("copied-event-url");
        this.deleteEventSuccessModal = document.getElementById("delete-event-success");
        this.deleteEventFailModal = document.getElementById("delete-event-fail");

        this.init();

    }

    toggleContextMenuButtonClicked(event) {
        
        let currentAriaExpanded = event.target.getAttribute("aria-expanded");

        if (currentAriaExpanded === "false") {

            this.openContextMenu();

        } else {

            this.closeContextMenu();

        }

    }

    openContextMenu() {
        
        this.toggleContextMenuButton.setAttribute("aria-expanded", "true");

    }

    closeContextMenu() {

        this.toggleContextMenuButton.setAttribute("aria-expanded", "false");

    }

    documentClicked(event) {

        let clickedElement = event.target;
        
        if (!this.contextMenu.contains(clickedElement)) {
            this.closeContextMenu();
        }

    }

    copyURLControlClicked(event) {

        // To test this functionality locally, make sure you visit http://localhost:8080 instead of 0.0.0.0:8080

        event.preventDefault();

        this.copyURL();

        this.closeContextMenu();

        this.copiedEventURLModal.modal.openModal();

    }

    copyURL() {

        const urlToCopy = this.copyURLControl.getAttribute("href");

        navigator.clipboard.writeText(urlToCopy);

    }

    deleteEventControlClicked() {

        this.closeContextMenu();

    }

    deleteEvent() {

        const deleteEventProxyURL = this.confirmDeleteEventControl.getAttribute("data-proxy-url");

        fetch(deleteEventProxyURL)
            .then(data => {
                this.deleteEventSuccessModal.modal.openModal();
                this.event.remove();
            })
            .catch(error => {
                this.deleteEventFailModal.modal.openModal();
            });
        
    }
    
    init() {

        // Bind click event to button
        this.toggleContextMenuButton.addEventListener("click", this.toggleContextMenuButtonClicked.bind(this));

        // Bind click event to copy url menu control
        this.copyURLControl.addEventListener("click", this.copyURLControlClicked.bind(this));

        this.deleteEventControl.addEventListener("click", this.deleteEventControlClicked.bind(this));

        this.confirmDeleteEventControl.addEventListener("click", this.deleteEvent.bind(this))

        document.addEventListener("click", this.documentClicked.bind(this));
        
    }

}


